import { ReactNode } from 'react'

import { Toggle } from '@tribeplatform/react-ui-kit/Toggle'

import { T, useI18n } from '../../i18n/index.js'

import { GenericSettings } from './GenericSettings.js'

interface Props {
  title: string
  enabled: boolean
  children: ReactNode
  setEnabled: (enabled: boolean) => void
  goBack: () => void
}
export const GenericFieldSettings = ({
  title,
  enabled,
  children,
  setEnabled,
  goBack,
}: Props) => {
  const intl = useI18n()
  const { $t } = intl

  return (
    <GenericSettings
      title={title}
      description={
        <T
          defaultMessage="Selected field settings"
          id="MultiViewBlock.FieldSettings.Selected"
        />
      }
      goBack={goBack}
    >
      <div className="space-y-5">
        <Toggle
          title={$t({ defaultMessage: 'Visible', id: 'Generics.Visible' })}
          checked={enabled}
          onChange={value => {
            setEnabled(value as boolean)
          }}
        />
        {children}
      </div>
    </GenericSettings>
  )
}
